import { render, staticRenderFns } from "./defult.vue?vue&type=template&id=3342c81a&"
import script from "./defult.vue?vue&type=script&lang=js&"
export * from "./defult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports